import type { ComponentProps } from "react"
import { HoverCard as HoverCardBase } from "@/v2-ui/hoverCard/base/HoverCardBase"

export type HoverCardProps = ComponentProps<typeof HoverCardBase>

function HoverCard(props: HoverCardProps) {
  const { ...selectBaseProps } = props
  return <HoverCardBase {...selectBaseProps} />
}

export default HoverCard
